// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"790":"e81304dab0bc8ab7","3377":"6afe087978d410d7","5746":"911d390320c75616"}[chunkId] + ".css";
};